/**
 * 冻结保留：充值扫码支付占位。本期默认不在用户下单主路径展示。
 * 样式依赖 ipe-credits-purchase-modal.css / recharge-cart-checkout-modal.css 的 __qr*，勿删。
 * 后期：传入 qrImageSrc（微信 code_url 生成图或支付宝跳转码），见 docs/payment-freeze/README.md
 */
import React from 'react';
import { QrCode } from 'lucide-react';
import {
  ONLINE_PAYMENT_COPY,
  getScanPaySurface,
} from '@/constants/onlinePaymentFreeze';

export default function RechargeScanPayPlaceholder({
  surface = 'purchase',
  qrImageSrc,
  label,
  alt,
}) {
  const config = getScanPaySurface(surface);
  const text = label || ONLINE_PAYMENT_COPY.qrChannelLabel;
  const classPrefix = config.classPrefix;
  const resolvedAlt = alt || `${text}扫码支付占位`;

  return (
    <div className={`${classPrefix}__qr`} data-online-pay-freeze="scan-placeholder">
      {qrImageSrc ? (
        <img
          className={`${classPrefix}__qr-image`}
          src={qrImageSrc}
          alt={resolvedAlt}
        />
      ) : (
        <>
          <div className={`${classPrefix}__qr-icon`} aria-hidden="true">
            <QrCode size={config.qrIconSize} strokeWidth={1.8} />
          </div>
          <span className={`${classPrefix}__qr-label`}>{text}</span>
        </>
      )}
    </div>
  );
}
